var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6425 10.4016C13.8647 10.1401 14 9.79488 14 9.41721C14 8.60313 13.3719 7.94065 12.6 7.94065H9.88276C10.1519 7.07932 10.2667 5.93646 10.2667 5.44657V4.95471C10.2667 3.86927 9.42916 2.98596 8.4 2.98596H7.93333C7.71929 2.98596 7.53262 3.13952 7.48067 3.35871L7.22649 4.43135C6.87027 5.93351 5.73938 7.59087 4.56898 7.89209C4.36396 7.34477 3.85778 6.95627 3.26667 6.95627H0.466667C0.209067 6.95627 0 7.17677 0 7.44846V16.3078C0 16.5795 0.209067 16.8 0.466667 16.8H3.26667C3.82324 16.8 4.30484 16.4558 4.5304 15.9584L6.13387 16.5221C6.65809 16.7065 7.2044 16.8 7.75724 16.8H11.6667C12.4385 16.8 13.0667 16.1375 13.0667 15.3235C13.0667 15.1315 13.0318 14.9478 12.9684 14.7794C13.562 14.6085 14 14.0346 14 13.3547C14 12.977 13.8647 12.6319 13.6425 12.3703C13.8647 12.1088 14 11.7636 14 11.386C14 11.0083 13.8647 10.6631 13.6425 10.4016ZM3.73333 15.3235C3.73333 15.5948 3.52396 15.8156 3.26667 15.8156H0.933333V7.94065H3.26667C3.52396 7.94065 3.73333 8.16148 3.73333 8.43284V15.3235ZM11.6667 10.8938H12.6C12.8573 10.8938 13.0667 11.1146 13.0667 11.386C13.0667 11.6573 12.8573 11.8781 12.6 11.8781H11.6667C11.4091 11.8781 11.2 12.0986 11.2 12.3703C11.2 12.642 11.4091 12.8625 11.6667 12.8625H12.6C12.8573 12.8625 13.0667 13.0834 13.0667 13.3547C13.0667 13.6261 12.8573 13.8469 12.6 13.8469H11.6667C11.4091 13.8469 11.2 14.0674 11.2 14.3391C11.2 14.6108 11.4091 14.8313 11.6667 14.8313C11.924 14.8313 12.1333 15.0521 12.1333 15.3235C12.1333 15.5948 11.924 15.8156 11.6667 15.8156H7.75724C7.30489 15.8156 6.85782 15.7392 6.4288 15.5883L4.66667 14.9688V8.87843C5.39871 8.73176 6.1152 8.24285 6.762 7.44256C7.39356 6.66096 7.90564 5.62474 8.13182 4.67023L8.29764 3.97034H8.4C8.91458 3.97034 9.33333 4.41199 9.33333 4.95471V5.44657C9.33333 6.10741 9.13733 7.37496 8.88658 7.94065H7.93333C7.67573 7.94065 7.46667 8.16115 7.46667 8.43284C7.46667 8.70452 7.67573 8.92502 7.93333 8.92502H12.6C12.8573 8.92502 13.0667 9.14585 13.0667 9.41721C13.0667 9.68857 12.8573 9.9094 12.6 9.9094H11.6667C11.4091 9.9094 11.2 10.1299 11.2 10.4016C11.2 10.6733 11.4091 10.8938 11.6667 10.8938Z",
    fill: "#730BDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.86706 0C8.60933 0 8.40039 0.220369 8.40039 0.492187V1.50937C8.40039 1.78119 8.60933 2.00156 8.86706 2.00156C9.12478 2.00156 9.33372 1.78119 9.33372 1.50937V0.492187C9.33372 0.220369 9.12478 0 8.86706 0Z",
    fill: "#730BDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.88629 2.17078L6.22633 1.47473C6.04412 1.28251 5.74862 1.28251 5.56637 1.47473C5.38413 1.66694 5.38413 1.97856 5.56637 2.17078L6.22633 2.86683C6.40855 3.05901 6.70408 3.05905 6.88629 2.86683C7.06854 2.67462 7.06854 2.363 6.88629 2.17078Z",
    fill: "#730BDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1666 1.47473C11.9843 1.28251 11.6889 1.28251 11.5066 1.47473L10.8466 2.17075C10.6644 2.36296 10.6644 2.67458 10.8466 2.8668C11.0289 3.05901 11.3244 3.05905 11.5066 2.86683L12.1666 2.17078C12.3488 1.97856 12.3488 1.66694 12.1666 1.47473Z",
    fill: "#730BDB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandUp);
export default __webpack_public_path__ + "static/media/hand-up.1c6148372824134b186656260f96c955.svg";
export { ForwardRef as ReactComponent };